// `Required` columns are for blocked columns(which user can not disable or enable)
// `Default` columns represent default state(e.g. when user see a table)
export const DEFAULT_COLUMNS = {
  list_loan_officers: {
    required: ['name'],
    default: ['name', 'nmls', 'company_name', 'organization_type', 'license_area', 'loan_volume'],
  },
  list_agents: {
    required: ['name'],
    default: [
      'name',
      'bre',
      'company_name',
      'sale_amount',
      'sale_quantity',
      'buyer_amount',
      'seller_amount',
      'dual_amount',
    ],
  },
  list_opportunities: {
    retuired: ['date'],
    default: [
      'completion_date',
      'borrower_name',
      'transaction_type',
      'loan_type',
      'loan_amount',
      'ltv',
      'sale_amount',
      'rate',
    ],
  },
  opportunities_search_results: {
    retuired: ['date'],
    default: [
      'completion_date',
      'loan_purpose',
      'loan_type',
      'loan_amount',
      'ltv',
      'sale_amount',
      'rate',
      'address_building',
      'borrower_name_1',
      'borrower_name_2',
    ],
  },
  search_result: {
    required: ['name'],
    default: [
      'name',
      'nmls',
      'company_name',
      'organization_type',
      'license_area',
      'loan_volume',
      'loan_volume_quantity',
      'tpo_assignment_volume',
      'tpo_assignment_quantity',
      'position',
      'purchase_percentage',
      'refinance_percentage',
      'construction_percentage',
      'heloc_percentage',
      'branch_address_state',
      'branch_address_city',
    ],
  },
  agents_search_results: {
    required: ['name'],
    default: [
      'name',
      'team_role',
      'bre',
      'company_name',
      'loan_amount',
      'sale_amount',
      'sale_quantity',
      'buyer_amount',
      'seller_amount',
      'dual_amount',
    ],
  },
  teams_search_results: {
    required: ['team_name'],
    default: [
      'team_name',
      'team_size',
      'team_lead',
      'company_name',
      'sale_amount',
      'sale_quantity',
      'buyer_amount',
      'seller_amount',
      'dual_amount',
    ],
  },
  agent_transactions: {
    required: ['date', 'trans_type', 'loan_type', 'loan_amount'],
    default: [
      'date',
      'address',
      'address_state',
      'address_city',
      'address_zip',
      'trans_type',
      'loan_type',
      'loan_amount',
      'ltv',
      'sales_price',
      'buyer_agency',
      'seller_agency',
    ],
  },
  agent_team_members: {
    required: ['rank', 'name'],
    default: [
      'rank',
      'name',
      'bre',
      // 'company_name', // TODO: uncomment when company names are normalized
      'address_state',
      'sale_amount',
      'sale_quantity',
      'buyer_amount',
      'seller_amount',
      'dual_amount',
    ],
  },
  profile_transactions: {
    required: ['date', 'trans_type', 'loan_type', 'loan_amount'],
    default: [
      'date',
      'address',
      'address_state',
      'address_city',
      'address_zip',
      'trans_type',
      'loan_type',
      'loan_amount',
      'ltv',
      'sales_price',
      'lender_company_name',
      'tpo_lender_name',
      'buyer_agency',
      'seller_agency',
    ],
  },
  realtor_transactions: {
    required: ['date', 'trans_type', 'loan_type', 'loan_amount'],
    default: [
      'date',
      'address',
      'address_state',
      'address_city',
      'address_zip',
      'loan_officer',
      'trans_type',
      'loan_type',
      'loan_amount',
      'sales_price',
      'buyer_agent',
      'seller_agent',
    ],
  },
  company_agent_transactions: {
    required: ['date', 'trans_type', 'loan_type', 'loan_amount'],
    default: [
      'date',
      'loan_officer',
      'address',
      'address_state',
      'address_city',
      'address_zip',
      'trans_type',
      'loan_type',
      'loan_amount',
      'sales_price',
      'buyer_agent',
      'seller_agent',
    ],
  },
  company_employees: {
    required: ['rank', 'name'],
    default: ['rank', 'name', 'nmls', 'loan_volume', 'loan_units', 'address_state'],
  },
  company_offices: {
    required: ['rank', 'manager'],
    default: [
      'rank',
      'manager',
      'office_id',
      'state',
      'city',
      'loan_officers',
      'loan_units',
      'loan_volume',
    ],
  },
  company_trends_search_results: {
    required: ['name'],
    default: [
      'name',
      'lo_gain_headcount',
      'lo_loss_headcount',
      'lo_growth_percentage',
      'lo_gain_loan_volume',
      'lo_loss_loan_volume',
      'proj_growth_loan_volume',
    ],
  },
  company_trends_details: {
    required: ['last_name'],
    default: ['last_name', 'nmls', 'company_name', 'loan_volume_quantity', 'loan_volume_amount'],
  },
};

export const AGENT_COMPANIES_COLUMNS = [
  'company_name',
  'loan_officers_count',
  'transactions_count',
  'transactions_volume',
];
export const LOAN_OFFICER_COMPANIES_COLUMNS = [
  'company_name',
  'agents_count',
  'transactions_count',
  'transactions_volume',
];
export const LOAN_OFFICERS_COLUMNS = [
  'name',
  'company_name',
  'transactions_count',
  'transactions_volume',
];
export const AGENTS_COLUMNS = ['name', 'company_name', 'transactions_count', 'transactions_volume'];
export const STRING_COLUMNS = ['company_name', 'name', 'company'];

export const ASC_SORTED_COLUMNS = [
  'address_state',
  'bre',
  'buyer_agent',
  'buyer_agency',
  'buyer_real_estate_agent_name',
  'buyer_real_estate_company',
  'company',
  'company_name',
  'loan_officer',
  'loan_officer_name',
  'loan_purpose',
  'loan_type',
  'name',
  'nmls',
  'organization_type',
  'seller_agent',
  'seller_agency',
  'seller_real_estate_agent_name',
  'seller_real_estate_company',
  'trans_type',
];
